import { fontFamily, fontWeight, tone, textSizeTrimmed, textSizeUntrimmed } from "./typography.css.mjs";
function textStyles({
  weight = "regular",
  size = "standard",
  tone: tone$1 = "neutral",
  baseline
}) {
  return [
    fontFamily,
    fontWeight[weight],
    tone[tone$1],
    (baseline ? textSizeTrimmed : textSizeUntrimmed)[size]
  ];
}
export {
  textStyles
};
